import i18n from "i18next";

export type Currency = string;

export function translateCurrency(amount: number | undefined, currency?: Currency): string {
  const formattedAmount = amount?.toLocaleString(i18n.language) || "";

  if (currency === undefined) {
    return formattedAmount;
  }

  const keyMap: Record<Currency, string> = {
    EUR: i18n.t("common.currency.amountInEUR", { amount: formattedAmount }),
    GBP: i18n.t("common.currency.amountInGBP", { amount: formattedAmount }),
    SEK: i18n.t("common.currency.amountInSEK", { amount: formattedAmount }),
    USD: i18n.t("common.currency.amountInUSD", { amount: formattedAmount }),
  };

  return keyMap[currency] || "";
}
